module.exports = __webpack_public_path__ + "93792441316838cd5b67931cab110c9e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/flower-pink-s.png
// module id = 2806
// module chunks = 0